module.exports = __webpack_public_path__ + "img/bb-bk.e93d15a3.svg";